const EMAIL_SEARCH_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface UserSearchContactPrefill {
  email?: string;
  phoneNumber?: string;
}

/** When a users search looks like an email or phone, map it for the add-user modal. */
export function parseUserSearchContact(
  query: string
): UserSearchContactPrefill | null {
  const trimmed = query.trim();
  if (!trimmed) return null;

  if (EMAIL_SEARCH_PATTERN.test(trimmed)) {
    return { email: trimmed.toLowerCase() };
  }

  const digits = trimmed.replace(/\D/g, "");
  if (/^[\d\s+\-().]+$/.test(trimmed) && digits.length >= 3) {
    return { phoneNumber: trimmed };
  }

  return null;
}

/** Placeholder stored for phone-only app users (see backend phone-only-app-users.md). */
export function isRealUserEmail(email?: string | null): boolean {
  if (!email) return false;
  const trimmed = email.trim();
  if (!trimmed) return false;
  if (trimmed.toUpperCase() === "N/A") return false;
  return true;
}

export function formatUserEmailDisplay(email?: string | null): string {
  return isRealUserEmail(email) ? email!.trim() : "—";
}
